import Box from '@mui/material/Box';
import VerifiedUser from '@mui/icons-material/VerifiedUserOutlined';
import Badge from '@mui/icons-material/BadgeOutlined';
import Assignment from '@mui/icons-material/AssignmentOutlined';
import Map from '@mui/icons-material/Map';
import UnitDetailContext from './UnitDetailContext';
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import { POLICY_INDEX } from '.';
import ErrorToast from "../../../components/toasts/ErrorToast";

const overdueDocumentIcons = [
  (<Badge className="unit-detail-document-icon"/>),
  (<Assignment className="unit-detail-document-icon"/>),
  (<Map className="unit-detail-document-icon"/>),
  (<VerifiedUser className="unit-detail-document-icon"/>)
]

type DocumentIconProps = {
  documentType: any,
  index: number
}

function DocumentIcon(props: DocumentIconProps) {
  const navigate = useNavigate()
  return (
    <UnitDetailContext.Consumer>
      { context => {
        let aa=0;
        const getDocument = (documentType: any, index: number) => {
          console.log('getDocument ',index,  documentType)
          let document = context.unit.documents.filter((it: any) => it.showDownloads && it.documentType.typeDoc.id === documentType.id)
          if (document.length===0){
           // alert("El documento seleccionado no existe para esta unidad")
           context.open = true
           context.documentTypeId= null;
           context.refresh()
          } else if (document.length > 1) {
            context.open = true
            context.documentTypeId= documentType.id;
            context.refresh()
          }
          else navigate(`/web/unit-detail/${context.unit.numberPlate}/documents/${document[0].id}`, { replace: true })
        }
        
        return (
          <Box className='unit-detail-document' onClick={() => getDocument(props.documentType, props.index)}>
            <Box className='unit-detail-document-icon-container'>
              {overdueDocumentIcons[props.index]}
            </Box>
            <Box className='unit-detail-document-text'>{props.documentType?.name}</Box>
            
          </Box>
        )
      }}
    </UnitDetailContext.Consumer>
  );
}

export default function() {
  return (
    <UnitDetailContext.Consumer>
      { context => {
        if (!context.documentTypes.length) return (<Box></Box>)
        const typeDocSet:any = new Set(context.documentTypes.map(item => item.typeDoc));
        const typeDocDistinct = [...typeDocSet];
        // Usar un conjunto para rastrear "id" único
        const conjuntoIds = new Set();

        // Filtrar el array original para obtener objetos únicos
        const resultado = typeDocDistinct.filter(item => {
            if (!conjuntoIds.has(item.id)) {
                conjuntoIds.add(item.id);
                return true;
            }
            return false;
        });
       
        return (
          <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="center"
          >
            {resultado?.map((documentType, index) => 
              <DocumentIcon key={index} documentType={documentType} index={index}></DocumentIcon>
            )}
          </Stack>
        )
      }}
    </UnitDetailContext.Consumer>
  );
}